// CheckoutForm.js
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { useState } from 'react';
import axios from "axios";
import base_url from "../../base_url";
import { localStorageUserKey } from '../../local_storage_vars';
import { smartStorage } from "../../smart_storage";

export default function CheckoutForm({ offerId, handymanAccountId, amount, handymanCommissionPercentage, reason, type, membership_duration, membershipId }) {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [paymentCompleted, setPaymentCompleted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); 
        setMessage('');

        const user = smartStorage.get(localStorageUserKey);
        
        const apiUrl = `${base_url}/apis/order/create-payment-intent`;

        try { 
            // 1. Create the PaymentIntent
            const response = await axios.post(apiUrl, {
                amount,
                handymanAccountId,
                handymanCommissionPercentage,
                offerId,
                reason,
                type,
                membership_duration,
                membershipId
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'authorization': user
                }
            });

            const { clientSecret, paymentIntentId } = response.data;

            // 2. Confirm the card payment
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                },
            });

            if (result.error) {
                setMessage(result.error.message);
                setLoading(false);
            } else {
                console.log("Payment succeeded!", paymentIntentId);
                setMessage('✅ Payment succeeded!');
                setLoading(false);
                setPaymentCompleted(true);
            }
        } catch (error) {
            console.error('PaymentIntent creation error:', error);
            setMessage('❌ Payment could not be initiated.');
            setLoading(false);
        }
    };

    return (
        <>
            {console.log({ stripe, loading, paymentCompleted, amount, reason })}
            <form onSubmit={handleSubmit} style={{ maxWidth: '100%' }} >
                <CardElement />
                <button disabled={stripe==null || loading || paymentCompleted} style={{ marginTop: '1em' }}>
                    {loading ? 'Processing…' : `Pay $${amount / 100}`}{paymentCompleted ? ' (Payment Completed)' : ''}
                </button>
            {message && 
            <div style={{ marginTop: '1em', color: 'red' }} dangerouslySetInnerHTML={{ __html: message }} />}
        </form>
        </>
    );
}
